import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"warning\"><path fill-rule=\"evenodd\" d=\"m23 21.5-11-19-11 19h22Zm-12-3v-2h2v2h-2Zm0-4v-4h2v4h-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol